import type { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { GetMRRQuery } from '../../data/queries/get-mrr.query'
import { type MRRResponse, DataType } from '../models/mrr'
import type { Resolution } from '../models/range'

export class GetMRRInteractor {
  constructor(private readonly getMRR: GetInteractor<MRRResponse>) {}

  public async execute(
    fromDate: string,
    toDate: string,
    resolution: Resolution,
    dataType: DataType,
    organization: string
  ): Promise<MRRResponse> {
    const apiDataType = dataType === DataType.Economics ? 'economics' : 'users'
    return await this.getMRR.execute(new GetMRRQuery(fromDate, toDate, resolution, apiDataType, organization))
  }
}
